import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { getAuthenticated } from 'utils/functions';
import {
  TicketsCardsContainer,
  TicketsCardsTitle,
  SelectTicketsButton,
  TicketsModalOverlay,
  TicketsModalBox,
  TicketsModalHeader,
  TicketsModalBody,
  TicketsModalFooter,
  ReserveButton,
} from './Theme';
import TicketsCard from './TicketsCard';
import { Fonts, FontWeights, FontColors } from "theme/fontConfig";

const TicketCards = ({
  ticketList,
  handleQuantityChange,
  totalTicket,
  allowNonMembers,
  onContinue,
  reserveButtonLabel,
  reserveButtonDisabled,
  reserveButtonLoading,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const isAuthenticated = getAuthenticated();

  if (!ticketList || !ticketList?.variantInfo) return null;

  const variants = ticketList.variantInfo;
  const selectedTotal = variants.reduce((sum, v) => sum + (v.selectedQuantity || 0), 0);

  if (variants.length === 1) {
    return (
      <TicketsCardsContainer>
        <TicketsCardsTitle>{ticketList?.title}</TicketsCardsTitle>
        <TicketsCard
          variant={variants[0]}
          handleQuantityChange={(value, type) => handleQuantityChange(0, value, type)}
          totalTicket={totalTicket}
          allowNonMembers={allowNonMembers}
        />
      </TicketsCardsContainer>
    );
  }

  return (
    <TicketsCardsContainer>
      <TicketsCardsTitle>{ticketList?.title}</TicketsCardsTitle>

      <SelectTicketsButton onClick={() => setModalOpen(true)}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
          <span style={{ fontSize: Fonts.GeneralSmallHeaderFont.fontSize, fontWeight: Fonts.GeneralSmallHeaderFont.fontWeight, color: FontColors.Blue002E5C }}>
            Select Tickets
          </span>
          <span style={{ fontSize: Fonts.GeneralCaptionFont.fontSize, color: FontColors.Slate64748B }}>
            {variants.length} ticket types available
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {selectedTotal > 0 && (
            <span style={{
              background: '#2555EF',
              color: FontColors.White,
              borderRadius: '12px',
              fontSize: Fonts.GeneralSmallLabelFont.fontSize,
              fontWeight: FontWeights.Bold,
              padding: '3px 10px',
              whiteSpace: 'nowrap',
            }}>
              {selectedTotal} selected
            </span>
          )}
          <span style={{ fontSize: Fonts.GeneralHeaderFont.fontSize, color: FontColors.Blue2555EF, fontWeight: Fonts.GeneralHeaderFont.fontWeight }}>›</span>
        </div>
      </SelectTicketsButton>

      {modalOpen && ReactDOM.createPortal(
        <TicketsModalOverlay onClick={() => setModalOpen(false)}>
          <TicketsModalBox onClick={e => e.stopPropagation()}>
            <TicketsModalHeader>
              <div>
                <div style={{ ...Fonts.GeneralSubHeaderFont, color: FontColors.Blue002E5C }}>
                  {ticketList?.title}
                </div>
                <div style={{ fontSize: Fonts.GeneralCaptionFont.fontSize, color: FontColors.Slate64748B, marginTop: 2, fontFamily: Fonts.GeneralCaptionFont.fontFamily }}>
                  {variants.length} ticket types
                </div>
              </div>
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  background: '#F5F6FA',
                  border: 'none',
                  borderRadius: '50%',
                  width: 32,
                  height: 32,
                  cursor: 'pointer',
                  fontSize: Fonts.GeneralSubHeaderFont.fontSize,
                  color: FontColors.Slate64748B,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: Fonts.GeneralSubHeaderFont.fontWeight,
                }}
              >
                ✕
              </button>
            </TicketsModalHeader>

            <TicketsModalBody>
              {variants.map((variant, index) => (
                <TicketsCard
                  key={index}
                  variant={variant}
                  handleQuantityChange={(value, type) => handleQuantityChange(index, value, type)}
                  totalTicket={totalTicket}
                  allowNonMembers={allowNonMembers}
                />
              ))}
            </TicketsModalBody>

            <TicketsModalFooter>
              {selectedTotal > 0 && (
                <span style={{
                  ...Fonts.GeneralSmallHeaderFont,
                  color: FontColors.Blue2555EF,
                }}>
                  {selectedTotal} selected
                </span>
              )}
              <ReserveButton onClick={() => setModalOpen(false)}>
                Continue
              </ReserveButton>
            </TicketsModalFooter>
          </TicketsModalBox>
        </TicketsModalOverlay>,
        document.body
      )}
    </TicketsCardsContainer>
  );
};

export default TicketCards;
